import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseQueryOptions, useQuery } from 'react-query'

export interface FontConfig {
  family: string
  weight: number
  italic: boolean
  line_height: number
  letter_spacing: number
  uppercase: boolean
}

export interface FontPairing {
  id: number
  name?: string
  description?: string
  cover_image_url: string
  header_font_config?: FontConfig
  body_font_config?: FontConfig
}

export const fetchFontPairings = async ({ signal }: { signal?: AbortSignal }) => {
  const res = await sendToApi<FontPairing[]>('/font_pairings', { signal })
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data
}

export const useFontPairings = (options?: UseQueryOptions<FontPairing[]>) => {
  return useQuery<FontPairing[]>(['fontPairings', 'list'], ({ signal }) => fetchFontPairings({ signal }), {
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
    ...options,
  })
}
